module.exports = __webpack_public_path__ + "media/images/emblems/Haeutligen-coat_of_arms-967aa2b99f43b4dcbbaab8364023ecea.svg";